<template>
  <div id="participants">
    Participants
    <BODParticipants :_id="$route.params.id" />
  </div>
</template>

<script>
import BODParticipants from "@/components/BODParticipants";
import Director from "../../mixin/guard/director";
export default {
  mixins: [Director],
  components: { BODParticipants },
};
</script>

<style></style>
